/**
 * Reads the `XSRF-TOKEN` cookie set by the BFF (Spring Security `CookieCsrfTokenRepository`).
 * Returns `null` if the cookie is absent — caller should still attempt the
 * request; the BE will reject unsafe methods with 403 if CSRF is genuinely required.
 */
export function readXsrfToken(): string | null {
  if (typeof document === 'undefined') return null;
  const match = /(?:^|;)\s*XSRF-TOKEN=([^;]+)/.exec(document.cookie);
  return match?.[1] !== undefined ? decodeURIComponent(match[1]) : null;
}

const UNSAFE_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

export function isUnsafeMethod(method: string): boolean {
  return UNSAFE_METHODS.has(method.toUpperCase());
}
